import { useData } from "../../../runtime/provider";
import LBox from "@components/LBox";
import LScreen from "@components/LScreen";
import LText from "@components/LText";
import BottomBarPadding from "@components/BottomBarPadding";
import { useManagedArtistIds } from "@hooks/trpc/useManagedArtists";
import { useManagedAccesses } from "@hooks/trpc/useManagedAccesses";
import { theme } from "@theme";

import { useEffect } from "react";
import { FlatList, RefreshControl } from "react-native";
import HeaderGroup from "@components/Account/Layout/Header/HeaderGroup";
import { PROFILE_ROUTES } from "@components/Account/Layout/utils";
import { captureException } from "@utils/captureException";
import ManagedAccessCard from "@components/Accesses/components/ManagedAccessCard";

const Accesses = () => {
  const session = useData();
  const {
    data: allAccesses,
    isFetchedAfterMount,
    refetch,
    isRefetching,
  } = useManagedAccesses("created");

  const accesses = allAccesses?.filter(
    (access) =>
      access.type === "event" &&
      !(Array.isArray(access.extLinks) && access.extLinks.length > 0),
  );

  const managedArtistId = useManagedArtistIds()?.[0];

  useEffect(() => {
    if (managedArtistId) {
      session.utils.catalog.artists.get
        .prefetch([managedArtistId])
        .catch((error) => {
          console.error(`::Accesses - prefetch error`, error);
          captureException(error, {
            channel: "breadcrumb",
            area: "query",
            operation: "prefetch-managed-artist",
          });
        });
    }
  }, [managedArtistId]);

  return (
    <LScreen enableAutomaticTopPadding={true}>
      <LBox pb="s4">
        <HeaderGroup routes={PROFILE_ROUTES} />
      </LBox>
      <LBox flex={1}>
        <FlatList
          data={accesses}
          ListFooterComponent={<BottomBarPadding />}
          showsVerticalScrollIndicator={false}
          refreshControl={
            <RefreshControl
              refreshing={isFetchedAfterMount && isRefetching}
              onRefresh={refetch}
              tintColor={"white"}
            />
          }
          contentContainerStyle={{
            rowGap: theme.spacing.s4,
          }}
          ListEmptyComponent={() => (
            <LBox flex={1} alignItems="center" justifyContent="center">
              <LBox width="70%">
                <LText
                  variant="inputTitle"
                  color="textGrey"
                  textAlign="center"
                  lineHeight={20}
                >
                  Internal event accesses you have created will appear here
                </LText>
              </LBox>
            </LBox>
          )}
          renderItem={({ item }) => <ManagedAccessCard access={item} />}
        />
      </LBox>
    </LScreen>
  );
};

export default Accesses;
